import { createContext } from 'react';

const defaultStaticText = {
  back: "Back",
  filters: "Filters",
  clearFilters: "Clear Filters",
  close: "Close",
  clearAll: "Clear All"
};
const FiltersInternalContext = createContext({
  staticText: defaultStaticText
});

export { FiltersInternalContext, defaultStaticText };
//# sourceMappingURL=api.es.js.map
